export const SET_TITLE = 'SET_TITLE';

export const setTitle = (title) => {
    return {
        type: SET_TITLE,
        title: title
    }
};

